import Loader from "react-loader-spinner";

const LoaderSpinner = () => {
  return <Loader type="Puff" color="#00BFFF" height={40} width={40} />;
};

export default LoaderSpinner;
